module.exports = __webpack_public_path__ + "img/mmexport1756284142806.1330448b.png";